import { createPostSchema } from "./characterLimit";

export const schema = (maxCharacters: number) => createPostSchema(maxCharacters);

interface FormValues {
  title: string;
  body: string;
  attached_files?: object[];
  attached_url?: string;
  content_categories?: number[];
  notificate_by_email: string[];
  notificate_by_telegram: string[];
  is_free: string[];
  group?: number;
  schedule_publish_at: string;
  action_publish_at: string;
  show_scheduled_post: string[],
  pinned: string[],
  block_files_download: string[],
  short_description: string,
  ask_for_phone: string[],
}

export const initialValues: FormValues = {
  title: "",
  body: "",
  notificate_by_email: ["true"],
  notificate_by_telegram: ["true"],
  is_free: [],
  schedule_publish_at: "",
  action_publish_at: "now_publication",
  show_scheduled_post: [],
  pinned: [],
  block_files_download: ["true"],
  short_description: "",
  ask_for_phone: ["true"],
};

